// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JobPreviewServiceName-base__vfRhN{margin-bottom:var(--size-0);color:var(--gray-12);font:var(--font-heading-h4);font-feature-settings:var(--feature-settings-heading-h4);letter-spacing:var(--letter-spacing-heading-h4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "JobPreviewServiceName-base__vfRhN"
};
export default ___CSS_LOADER_EXPORT___;
